<script setup lang="ts">
import { type PropType, watch } from 'vue';
import { type HtmlContentConfig } from '../models/html-content-config.model';
import { useHtmlContent } from '../composables/html-content.composable';

const props = defineProps({
  config: {
    type: Object as PropType<HtmlContentConfig>,
    required: true
  },
  visible: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['update:loaded']);

const { htmlContent } = useHtmlContent(props.config);

watch(
  htmlContent,
  () => {
    emit('update:loaded', htmlContent.value !== undefined);
  },
  { deep: true, immediate: true }
);
</script>

<template>
  <template v-if="visible && htmlContent">
    <div v-html="htmlContent.html"></div>
  </template>
</template>
